import { render } from "./EditClubInformation.vue?vue&type=template&id=64590d28&ts=true"
import script from "./EditClubInformation.vue?vue&type=script&lang=ts"
export * from "./EditClubInformation.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__